import * as React from "react";
import {observer} from "mobx-react";

import {MapState} from "../../core/map-state";
import {AppState} from "../app/app-mobx";

export interface LayerFilterProps {
    mapStore: MapState;
    appStore: AppState;
    featureLayer: __esri.FeatureLayer;
}

@observer
export class LayerFilter extends React.Component<LayerFilterProps, any> {
    constructor(props: LayerFilterProps) {
        super(props);
    }

    render() {
        const featureLayer = this.props.featureLayer;
        const { appStore, mapStore } = this.props;

        if ( appStore.subtopic?.layers.visible.some((l)=> l.id === featureLayer.id)) {
            // activate layer
            if (mapStore.view) {
                mapStore.view.whenLayerView(featureLayer)
                    .then((layerView) => {
                        const featureLayerView = layerView as __esri.FeatureLayerViewProperties;
                        featureLayerView.filter = appStore.subtopic?.filter;
                    })
                    .catch((error) => {
                        // the view is uninitialized until the stations have been loaded to the mobx store
                        // eslint-disable-next-line no-console
                        console.error(error);
                    });
            }
            featureLayer.visible = true;
            // remember visible layer
            mapStore.addVisibleFilterLayer(featureLayer.id, featureLayer);
        } else {
            // deactivate layer
            featureLayer.visible = false;
            mapStore.removeVisibleFilterLayer(featureLayer.id);
        }

        return null;
    }

    componentDidMount(): void {}
}
